/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import type { EditorModule } from "document-model";
import { AppEditor } from "./app-editor/module.js";
import { DocumentEditorEditor } from "./document-editor/module.js";
import { ProcessorModuleEditor } from "./processor-editor/module.js";
import { SubgraphModuleEditor } from "./subgraph-editor/module.js";
import { VetraDriveApp } from "./vetra-drive-app/module.js";
import { VetraPackageEditor } from "./vetra-package/module.js";

export const editors: EditorModule[] = [
  AppEditor,
  DocumentEditorEditor,
  ProcessorModuleEditor,
  SubgraphModuleEditor,
  VetraDriveApp,
  VetraPackageEditor,
];
